import Vue from 'vue';
import Vuex from 'vuex';
import { db } from '@/db.js';

import firebase from 'firebase/app';
import 'firebase/auth';
import { getField, updateField } from 'vuex-map-fields';
import { vuexfireMutations, firestoreAction } from 'vuexfire';
// import { db } from '@/db';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        current: { value_: 0 },
        // current: null,
        // current: [],
        errorMessage: {
            short: '',
            long: '',
            error: false,
        },
        paymentsRef: '',
        format: {
            date: 'DD.MM.YYYY',
            dateDM: 'DD.MM.',
            language: 'de-at',
        },
        payment: {
            amount: '',
            date: '',
            text: '',
        },
        toggle: {
            current: {
                cModal: false,
            },
            singlePayment: {
                spModal: {
                    open: false,
                    action: 'add',
                },
            },
        },
        user: {
            uid: '',
            displayName: '',
            photoURL: '',
            email: '',
        },
    },
    mutations: {
        updateField,
        ...vuexfireMutations,
        CLEAR_PAYMENT(state) {
            state.payment.amount = '';
            state.payment.date = '';
            state.payment.text = '';
        },
        SET_CURRENT_MODAL(state, payload) {
            state.toggle.current.cModal = payload;
        },
        SET_ERROR_MESSAGE(state, payload) {
            state.errorMessage = payload;
        },
        SET_PAYMENT(state, payload) {
            state.payment = payload;
        },
        SET_PAYMENT_REF(state, payload) {
            state.paymentsRef = payload;
        },
        SET_SINGLEPAYMENT_MODAL(state, payload) {
            state.toggle.singlePayment.spModal = payload;
        },
        UPDATE_USER(state, payload) {
            state.user = payload;
        },
    },
    actions: {
        // bindCurrent: firestoreAction(({ state, bindFirestoreRef }) => {
        //     console.log('state:', state);
        //     return bindFirestoreRef(
        //         'current',
        //         db.collection('payments').doc(state.user.uid).collection('current').doc('value'),
        //     );
        // }),
        bindCurrent({ state }) {
            // console.log('stateStore:', state);
            return new Promise((resolve, reject) => {
                state.paymentsRef.collection('current').doc('value')
                    .get()
                    .then(doc => {
                        if (doc.exists) {
                            // console.log('docStore:', doc.data());
                            state.current = doc.data();
                        } else {
                            // console.log('ELSE docStore:', doc);
                            // console.log('ELSE docStore:', state.user.uid);
                            // state.current.value_ = 0;
                        }
                        resolve();
                    })
                    .catch(error => {
                        state.errorMessage.short = error;
                        reject();
                    });
            });
        },
        getPaymentRef({ state, commit }) {
            const ref = db.collection('payments').doc(state.user.uid);
            commit('SET_PAYMENT_REF', ref);
            return ref;
        },
        getUserId({ commit }) {
            const { currentUser } = firebase.auth();
            if (currentUser) {
                commit('UPDATE_USER', currentUser);
            } else {
                commit('UPDATE_USER');
            }
        },
        updateCurrent: firestoreAction(({ state, commit, dispatch }, payload) => db
            .collection('payments').doc(state.user.uid).collection('current').doc('value')
            .set({ value_: payload })
            .then(() => dispatch('bindCurrent'))
            .catch(error => {
                commit('SET_ERROR_MESSAGE', { short: 'Could not save!', long: error, error: true });
            })),
    },
    getters: {
        getField,
    },
    modules: {
    },
});
